import LooseItemsTable from './LooseItemsTable';

export default LooseItemsTable;
